import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { IstateVv } from './vv-types';
import scanDataReducers from './extra-reducers/scan-data-reducers';

const initial: IstateVv = {
  loading: {},
  data: {},
  errors: {},
  error: null,
  photos: [],
  country: null,
};

export const vvSlice = createSlice({
  name: 'vv-slice',
  initialState: initial,
  reducers: {
    // reset: () => initial,
    reset: (state) => {
      Object.assign(state, {
        loading: {},
        data: {},
        errors: {},
        error: null,
        photos: [],
      });
    },

    setError: (
      state: Draft<IstateVv>,
      action: PayloadAction<string | null>
    ) => {
      state.error = action.payload;
    },

    setCountry: (
      state: Draft<IstateVv>,
      action: PayloadAction<string | null>
    ) => {
      state.country = action.payload;
    },

    setphotos: (
      state: Draft<IstateVv>,
      action: PayloadAction<{ data: string[] }>
    ) => {
      state.photos.length = 0; // Очищаем массив
      state.photos.push(...action.payload.data); // Добавляем новые данные
    },
  },
  extraReducers: (builder) => {
    scanDataReducers(builder);
  },
});

export const { setError, setphotos, reset, setCountry } = vvSlice.actions;
export default vvSlice.reducer;
